<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="mt-4 ml-4">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="'Orders'"></span>
        </v-col>
      </v-row>

      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    @keydown.enter="getData"
                    @change="page = 1"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-progress-linear
        v-if="isLoading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6">
            <v-card-title v-if="orders.length != 0">
              <v-spacer></v-spacer>
              <v-btn class="primary mx-4" @click="generateExcel()">
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Date</th>
                    <th class="text-left">Invoice No</th>
                    <th class="text-left">Invoice Date</th>
                    <th class="text-left">User</th>
                    <th class="text-left">Beat</th>
                    <th class="text-left">Outlet</th>
                    <th class="text-left">Order Type</th>
                    <th class="text-left">Order Details</th>
                    <th class="text-left">Total</th>
                    <!-- <th class="text-right">Action</th> -->
                  </tr>
                </thead>
                <tbody v-if="orders.length != 0">
                  <tr v-for="(order, i) in orders" :key="`order${i}`">
                    <td style="min-width: 85px">
                      {{ i + 1 }}
                    </td>
                    <td>{{ order.date || "" }}</td>
                    <td>{{ order.invoice_no || "" }}</td>
                    <td>{{ order.invoice_date || "" }}</td>
                    <td>{{ order.user.name || "" }}</td>
                    <td>{{ order.pjp ? order.pjp.beat?.name : "" || "" }}</td>
                    <td>{{ order.pjp ? order.pjp.location : "" || "" }}</td>
                    <td>{{ order.order_type || "" }}</td>
                    <td class="text-center" style="min-width: 225px">
                      <v-expansion-panels>
                        <v-expansion-panel>
                          <v-expansion-panel-header>
                            List of Details
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-simple-table fixed-header>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">SKU</th>
                                    <th class="text-left">Date</th>
                                    <th class="text-left">Qty</th>
                                    <th class="text-left">Value</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(
                                      order_detail, u
                                    ) in order.order_details"
                                    :key="`order_detail${u}`"
                                  >
                                    <td style="min-width: 185px">
                                      {{ order_detail.sku.name }}
                                    </td>
                                    <td>{{ order_detail.date }}</td>
                                    <td>{{ order_detail.qty }}</td>
                                    <td>{{ order_detail.value }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </td>
                    <td>{{ order.total || "" }}</td>

                    <!-- <td class="text-right">
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        :to="`/orders/${order.id}`"
                      >
                        <v-icon dark> mdi-pencil </v-icon>
                      </v-btn>
                    </td> -->
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="12" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "ordersPage",
  data() {
    return {
      form: {
        active: 1,
      },
      orders: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      search_keyword: "",
      isLoading: false,
      isExcelloading: false,
      ExportUsers: [],
      Export_orders: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.active = this.active ? this.active : "";
      this.role_id = this.role_id ? this.role_id : "";
      let orders = [];
    let query = "page=" + this.page + "&rowsPerPage=" + this.rowsPerPage;
      orders = await axios.get(`orders?${query}`);
      this.orders = orders.data.data;
      // this.orders = orders.data.data.filter(user => {
      //   return user.roles[0].name === 'USER';
      // });
      // console.log(this.orders);
      this.count = orders.data.count;
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },
    //  async Delete_this(id) {
    //   let check = confirm("Are you sure you want to delete the data");
    //   if (check) {
    //     try {
    //       this.isLoading = true;
    //       await axios.delete(`orders/${id}`);
    //       this.isLoading = false;
    //       this.getData();
    //     } catch (e) {
    //       this.isLoading = false;
    //     }
    //   }
    // },

    async addToExcelData() {
      this.isExcelLoading = true;
      this.title = "Company Lists";
      let Export_orders = [];
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.active +
        "&roleId=" +
        this.form.role_id;
      Export_orders = await axios.get(`orders?${query}`);
      this.Export_orders = Export_orders.data.data;

      this.Export_orders.forEach((order) => {
        this.ExportUsers.push({
          sr_no: order.sr_no,
          name: order.name ? order.name.toUpperCase() : "",
        });
      });
      this.isExcelLoading = false;
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.isLoading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.active = this.active ? this.active : "";
      this.role_id = this.role_id ? this.role_id : "";
      let query =
        "search_keyword=" +
        this.search_keyword +
        "&is_active=" +
        this.form.active +
        "&roleId=" +
        this.form.role_id +
        "&supervisorId=" +
        this.form.supervisor_id +
        "&designationId=" +
        this.form.designation_id;
      try {
        let response = await axios.get(`ordersExports?${query}`);
        if (response && response.data && response.data.data) {
          window.open(`${response.data.data}`, "_blank");
        } else {
          console.error("Invalid response data:", response.data);
        }
      } catch (error) {
        console.error("Error fetching Excel data:", error);
      }
      this.getData();
      this.isExcelloading = false;
      console.log("a");
    },
  },
};
</script>
